import { AbstractControl, FormArray, ValidatorFn } from '@angular/forms';

import { FeedAdviceType } from '../models/feed-advice.model';

const isEmptyObject = (obj: unknown): boolean =>
  obj && Object.keys(obj).length === 0 && obj.constructor === Object;

export const firstDayValidator =
  (
    dayFromArray: FormArray,
    feedAdviceType: FeedAdviceType,
    transition: { day?: number },
  ): ValidatorFn =>
  (control: AbstractControl): { [key: string]: boolean } | null => {
    const index = dayFromArray.controls.findIndex((x) => x === control) as number;
    if (index === 0) {
      if (control.value) {
        let errors = control.errors ? Object.assign({}, control.errors) : {};
        if (
          ((control.value as number) === 1 && !transition?.day) ||
          (feedAdviceType === FeedAdviceType.SOWS_FARROWTOWEAN &&
            (control.value as number) === transition?.day)
        ) {
          if (Object.prototype.hasOwnProperty.call(errors, 'firstDay')) {
            delete errors.firstDay;
          }
          control.setErrors(isEmptyObject(errors) ? null : errors);
          return null;
        } else {
          errors = { ...errors, firstDay: false };
          control.setErrors(errors);
          return errors;
        }
      }
    }
  };
